import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Divider } from "@mui/material";

import { Container } from "../../../components/Container";
import { CustomButton } from "../../../components/CustomButton";
import { Icon, IconNameEnum, IconTypeEnum } from "../../../components/Icon";
import { putUpdateBillingThunk } from "../../../reducers/billingReducer";
import {
  getBillingBilling,
  getBillingIsUpdating,
  getIsBillingInNewStatus,
  getIsZeroYearBilling,
} from "../../../selectors/billing";
import { useAppDispatch } from "../../../store";
import { BillingFeeCalculationSummaryItem } from "../BillingFeeCalculationSummaryItem";
import { BillingWeightedFeeCalculation } from "../BillingWeightedFeeCalculation";
import { BillingZeroYearFeeCalculation } from "../BillingZeroYearFeeCalculation";

import styles from "./BillingFeeCalculation.module.scss";

export const BillingFeeCalculation: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isBillingInNewStatus = useSelector(getIsBillingInNewStatus);
  const isUpdating = useSelector(getBillingIsUpdating);
  const isZeroYear = useSelector(getIsZeroYearBilling);

  const billing = useSelector(getBillingBilling);

  const handleCalculate = async () => {
    await dispatch(putUpdateBillingThunk());
  };

  return (
    <Container>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.headerTitle}>
            {t(isZeroYear ? "billingZeroYearFeeCalculation.title" : "billingFeeCalculation.title")}
          </h2>
          <CustomButton
            text={t("billingFeeCalculation.calculate")}
            onClick={handleCalculate}
            disabled={isUpdating || !isBillingInNewStatus}
          />
        </div>
        {isZeroYear ? <BillingZeroYearFeeCalculation /> : <BillingWeightedFeeCalculation />}
        <Divider />
        <div className={styles.footer}>
          <BillingFeeCalculationSummaryItem
            label={t("billingFeeCalculation.expectedWasteCosts")}
            value={billing.expectedExpenseSummary}
          />
          <BillingFeeCalculationSummaryItem
            label={t("billingFeeCalculation.totalFee")}
            value={billing.totalNetFeeSum}
            secondaryValue={billing.totalFeeSum}
          />
          <BillingFeeCalculationSummaryItem
            label={t("billingFeeCalculation.expectedBalance")}
            value={billing.totalFeeSum - billing.expectedExpenseSummary}
            isBalance
          />
        </div>
        {isZeroYear && (
          <div className={styles.legalNotice} role="note">
            <Icon name={IconNameEnum.info} type={IconTypeEnum.grey} />
            <p>{t("billingZeroYearFeeCalculation.legalNotice")}</p>
          </div>
        )}
      </div>
    </Container>
  );
};
